export const LIVE_ROOM_LIVE_NOW_PER_PAGE = 1;
